import { render, staticRenderFns } from "./AddMemberDialog.vue?vue&type=template&id=1967abd0&scoped=true"
import script from "./AddMemberDialog.vue?vue&type=script&lang=js"
export * from "./AddMemberDialog.vue?vue&type=script&lang=js"
import style0 from "./AddMemberDialog.vue?vue&type=style&index=0&id=1967abd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1967abd0",
  null
  
)

export default component.exports